import {
  getAdvOption,
  getAllAdvertisingSection,
  getInfoAdvertisingSection,
  saveAdvertising,
  getAdvertisingActive
} from '@/apis/advertising-option';
import { ADVERTISING } from '../mutation-types';

export const state = {
  advertisingOption: [],
  allAdvertisingSection: [],
  infoAdvertisingSection: null,
};

export const getters = {
  advertisingOption: state => state.advertisingOption,
  allAdvertisingSection: state => state.allAdvertisingSection,
  infoAdvertisingSection: state => state.infoAdvertisingSection
};

export const mutations = {
  [ADVERTISING.ADVERTISING_OPTION](state, data) {
    if (!data.error) {
      state.advertisingOption = data;
    }
  },

  [ADVERTISING.ALL_ADVERTISING_SECTION](state, data) {
    if (!data.error) {
      state.allAdvertisingSection = data;
    }
  },

  [ADVERTISING.GET_INFO_ADVERTISING_SECTION](state, data) {
    if (!data.error) {
      state.infoAdvertisingSection = data;
    }
  },
};

export const actions = {
  async getAdvOption({ commit }, params) {
    const res = await getAdvOption(params);
    commit(ADVERTISING.ADVERTISING_OPTION, res);
  },

  async getAllAdvertisingSection({ commit }) {
    const res = await getAllAdvertisingSection();
    commit(ADVERTISING.ALL_ADVERTISING_SECTION, res);
  },

  async getInfoAdvertisingSection({ commit }, params) {
    const res = await getInfoAdvertisingSection(params);
    commit(ADVERTISING.GET_INFO_ADVERTISING_SECTION, res);

    return res;
  },

  async saveAdvertising({ commit }, payload) {
    const res = await saveAdvertising(payload);

    return res;
  },

  async getAdvertisingActive({ commit }) {
    const res = await getAdvertisingActive();

    return res;
  }
};
